var _path;

var _excluded = ["title", "titleId"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgress0(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM3.9217 16C3.9217 22.6707 9.32934 28.0783 16 28.0783C22.6707 28.0783 28.0783 22.6707 28.0783 16C28.0783 9.32934 22.6707 3.9217 16 3.9217C9.32934 3.9217 3.9217 9.32934 3.9217 16Z",
    fill: "#E8E8E6"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress0);
export default __webpack_public_path__ + "static/media/progress_0.e8aefef6a9c336a4314e621c15b0da9b.svg";
export { ForwardRef as ReactComponent };